/// <amd-module name="TFS/Admin/Views/ProjectPermissions/Contracts/DataModels" />

import { MessageCardSeverity } from "VSSUI/MessageCard";
import { GraphMember } from "VSS/Platform/Contracts/Graph";
import { PermissionLevelAssignment } from "TFS/Admin/Common/Contracts/PermissionLevel";
import { IIdentity } from "VSSUI/IdentityPicker";

export interface IProjectMembers {
    name: string;
    permissions: string;
    type: string;
}

export interface IPermissionsMessage {
    name: string;
    severity: MessageCardSeverity;
}

export interface IProjectPermissionMembers {
    member: IIdentity;
    permissionLevelAssignment: PermissionLevelAssignment;
}
